import {catchError,first,map} from 'rxjs/operators';
import {Observable,of,OperatorFunction} from 'rxjs';
import {ToastrService} from 'ngx-toastr';
import {TranslateService} from '@ngx-translate/core';
import {Result,TypeCodeErreur} from "@domain/common/http/result";

/**
 * Fonction permettant de gérer par défaut le retour d'un résultat HTTP
 * Cette fonction est utilisée comme opérateur dans un pipe RxJS pour traiter
 * les réponses des appels API et afficher les messages appropriés
 *
 * @param translateService Service de traduction pour l'internationalisation des messages
 * @param toastrService Service de notification pour afficher les messages de succès/erreur
 * @param successTranslate Clé de traduction pour le message de succès (null pour ne pas afficher)
 * @param errorTranslate Clé de traduction pour le message d'erreur (null pour utiliser le code d'erreur)
 * @returns Un opérateur RxJS qui transforme l'Observable<Result>
 */
export function handleResult<T = any>(
    translateService: TranslateService,
    toastrService: ToastrService,
    successTranslate: string = 'global.success.enregistrement',
    errorTranslate: string = 'global.errors.enregistrement'
): OperatorFunction<Result<T>,Result<T>> {
    return (source: Observable<Result<T>>) =>
        source.pipe(
            first(),
            map((result: Result<T>) => {
                if (result.codeErreur === TypeCodeErreur.NO_ERROR) {
                    //Affiche un message de succès si une clé de traduction est fournie
                    if (successTranslate != null) {
                        toastrService.success(
                            translateService.instant(successTranslate)
                        );
                    }
                    return result;
                } else if (errorTranslate == null) {
                    //Si pas de message d'erreur personnalisé, utilise le code d'erreur standard
                    TypeCodeErreur.showError(
                        result.codeErreur,
                        translateService,
                        toastrService
                    );
                    return null;
                } else {
                    //Affichage du message personnalisé
                    toastrService.error(
                        translateService.instant(errorTranslate)
                    );
                }
            }),
            catchError(() => {
                //Affiche un message d'erreur générique si une clé de traduction est fournie
                if (errorTranslate != null) {
                    toastrService.error(
                        translateService.instant(errorTranslate)
                    );
                }
                //Retourne null pour indiquer l'échec de l'opération
                return of(null);
            })
        );
}